import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class HorizontalAlignment extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, HorizontalAlignment._types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static LEFT = new AString('left'); // TODO: Add Meta decorator
    public static CENTER = new AString('center');
    public static RIGHT = new AString('right');
    public static STRETCH = new AString('stretch');

    private static _types:Array<AString> = [
        HorizontalAlignment.LEFT,
        HorizontalAlignment.CENTER,
        HorizontalAlignment.RIGHT,
        HorizontalAlignment.STRETCH,
    ];

    public static isLeft(align:HorizontalAlignment):boolean
    {
        return align.value.value === HorizontalAlignment.LEFT.value;
    }

    public static isRight(align:HorizontalAlignment):boolean
    {
        return align.value.value === HorizontalAlignment.RIGHT.value;
    }

    public static isCenter(align:HorizontalAlignment):boolean
    {
        return align.value.value === HorizontalAlignment.CENTER.value;
    }

    public static isStretch(align:HorizontalAlignment):boolean
    {
        return align.value.value === HorizontalAlignment.STRETCH.value;
    }

    public static left():HorizontalAlignment
    {
        return new HorizontalAlignment(HorizontalAlignment.LEFT);
    }

    public static center():HorizontalAlignment
    {
        return new HorizontalAlignment(HorizontalAlignment.CENTER);
    }

    public static right():HorizontalAlignment
    {
        return new HorizontalAlignment(HorizontalAlignment.RIGHT);
    }

    public static stretch():HorizontalAlignment
    {
        return new HorizontalAlignment(HorizontalAlignment.STRETCH);
    }

    public static fromString(value:string):HorizontalAlignment
    {
        return new HorizontalAlignment(AString.fromString(value));
    }
}
